export const ADD_CATEGORIES = "ADD_CATEGORIES";
export const ADD_FAKE_CATEGORIES = "ADD_FAKE_CATEGORIES";
